<template>
  <v-container class="gym-pass-select p-0" v-if="facilityType" fluid>
    <vue-headful :title="$t('header.facility') + $t('title')"></vue-headful>

    <HkiaraceBannerFrame :src="host + 'static/'+facilityType.banner"
                         :label="facilityType.name.toUpperCase()"
                         no-transform-content>
      <v-container class="facility-info-details">
        <v-row>
          <v-col>
            <table class="gym-pass-type-table">
              <thead>
              <tr>
                <td v-for="type in subscriptionTypes"
                    :class="[{'selected': type.id === selectedSubscriptionTypeId}, 'gym-pass-type-table-thead']">
                  {{ type.name }}
                </td>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td v-for="type in subscriptionTypes" v-html="type.description"
                    :class="[{'selected': type.id === selectedSubscriptionTypeId}, 'gym-pass-type-table-td']"
                    @click="selectedSubscriptionTypeId = type.id"></td>
              </tr>
              </tbody>
            </table>
          </v-col>
        </v-row>

      </v-container>
    </HkiaraceBannerFrame>

    <v-row class="facility-reserve-steps py-2 px-2 py-md-6 px-md-6">
      <v-col cols="12" v-if="$vuetify.breakpoint.width > 600">
        <v-avatar color="primary" size="36">
          <span class="text-white">1</span>
        </v-avatar>
        <span>{{ $t('booking.step_1') }}</span>
        <v-icon>mdi-arrow-right</v-icon>
        <v-avatar color="grey" size="36">
          <span class="text-white">2</span>
        </v-avatar>
        <span class="text-muted">{{ $t('booking.step_2') }}</span>
        <v-icon>mdi-arrow-right</v-icon>
        <v-avatar color="grey" size="36">
          <span class="text-white">3</span>
        </v-avatar>
        <span class="text-muted">{{ $t('booking.step_3') }}</span>
        <!--                    <v-btn color="primary" rounded large-->
        <!--                           :disabled="!selectedTimeSlots.length"-->
        <!--                           @click="reserveTimeSlots"-->
        <!--                           class="ml-9">-->
        <!--                        <v-icon>mdi-arrow-right-circle-outline</v-icon>-->
        <!--                        {{$t('booking.next_step')}}-->
        <!--                    </v-btn>-->
      </v-col>
      <v-col cols="6" v-if="$vuetify.breakpoint.width <= 600" class="text-left font-size-25">
        <v-row>
          <v-col>
            <v-avatar color="primary" size="36">
              <span class="text-white">1</span>
            </v-avatar>
            <span>{{ $t('booking.step_1') }}</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-avatar color="grey" size="36">
              <span class="text-white">2</span>
            </v-avatar>
            <span class="text-muted">{{ $t('booking.step_2') }}</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-avatar color="grey" size="36">
              <span class="text-white">3</span>
            </v-avatar>
            <span class="text-muted">{{ $t('booking.step_3') }}</span>
          </v-col>
        </v-row>
      </v-col>

      <v-col :class="$vuetify.breakpoint.width <= 600?'text-center':'text-right'" :cols="$vuetify.breakpoint.width <= 600?6:12">
        <v-btn color="primary" rounded :large="$vuetify.breakpoint.width>600"
               class="ml-2 my-2"
               :disabled="!selectedSubscriptionTypeId"
               @click="next">
          <v-icon>mdi-arrow-right-circle-outline</v-icon>
          <span class="font-size-35">{{ $t('booking.next_step') }}</span>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import HkiaraceBannerFrame from "@/components/HkiaraceBannerFrame";
import {HOST} from "@/main";
import {onMounted, ref} from '@vue/composition-api';

export default {
  name: 'GymPassSelect',
  components: {HkiaraceBannerFrame},
  setup(props, {root}) {
    const facilityTypeId = ref(root.$route.params.facilityTypeId);
    const facilityType = ref(null);
    const getFacilityType = function () {
      root.$callAPI('aafb/facility_types/', {type_id: facilityTypeId.value}, function (response) {
        facilityType.value = response.body.item_type;
      });
    };

    const subscriptionTypes = ref([]);
    const getSubscriptionTypes = function () {
      root.$callAPI('aafb/gym_subscription/types/', {}, function (response) {
        subscriptionTypes.value = response.body.subscription_types;
      });
    };

    const selectedSubscriptionTypeId = ref(null);

    const next = function () {
      root.$callAPI('aafb/gym_subscription/create/', {type_id: selectedSubscriptionTypeId.value}, function (response) {
        root.$router.push({name: 'gym-pass-preview', params: {subscriptionId: response.body.subscription_id}});
      });
    };


    onMounted(() => {
      getFacilityType();
      getSubscriptionTypes();
    })

    return {
      host: HOST,
      facilityType,
      subscriptionTypes,
      selectedSubscriptionTypeId,
      next,
    };
  }
}
</script>

<style lang="less">
.gym-pass-select {
  .facility-info-details {
    background-color: white;

    .gym-pass-type-table {
      width: 100%;
      border-collapse: separate;
      border-spacing: 0;

      p {
        margin: 0px !important;
      }

      td {
        border: #d6d6d6 1px solid;
        cursor: pointer;

        &.selected {
          border-color: #998065 !important;
        }
      }
    }

    .gym-pass-type-table-thead {
      padding: 8px;
    }

    .gym-pass-type-table-td {
      padding: 16px;
    }
  }

  .facility-reserve-steps {
    .v-avatar {
      margin-right: 12px;
    }

    .mdi-arrow-right {
      margin-left: 24px;
      margin-right: 12px;
    }
  }
}
</style>
